import React from "react";
import "./Intro.css"

export default function Intro(props) {
    return <div className="intro-container"> 
    <h2>{props.header}</h2>
    <p>{props.content}</p>

    </div>
}